import LoginHoldPopup from './index';
import ReactDOM from 'react-dom/client'


export const openLoginHoldPopup = (
    params: {
        onClose?: Function, // 取消回调
    },
) => {
    const { onClose, ...rest } = params
    const dom = document.getElementById('loginHoldPopupWrapper')
    dom && dom.parentElement && dom.parentElement.removeChild(dom)
    const container = document.createElement('div')
    const id = 'loginHoldPopupWrapper'
    container.setAttribute('id', id)
    document.body.appendChild(container)
    const root = ReactDOM.createRoot(container)

    const cancel = () => {
        root.unmount()
        container && container.parentElement && container.parentElement.removeChild(container)
    }
    window.addEventListener('popstate', function (event) {
        cancel()
    })

    return root.render(
        <LoginHoldPopup
            onClose={(e: any) => {
                cancel();
                e && onClose?.(e);
            }}
            {...rest}
        />,
    )
}